module.exports = __webpack_public_path__ + "media/images/title_bg_horizontal_lc-9fd816edc44da22ab64e51143241a815.png";